import { OreButton, OreStack, SvgArrowLeft } from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useBankAccount } from '@/Contract/ui/context'
import { contractTranslation } from '@/Contract/ui/contractTranslation'
import { BankAccountChangeForm } from '@/Contract/ui/hooks'

export const Step1Actions = ({ simplified = false }): JSX.Element => {
  const { t } = useTranslation()
  const { getSepaDocument, navigateToOrigin } = useBankAccount()
  const { handleSubmit } = useFormContext<BankAccountChangeForm>()

  return (
    <OreStack space="large" direction="row" placeContent="space-between">
      <OreButton
        data-testid="previous"
        category={'tertiary'}
        icon={<SvgArrowLeft />}
        onClick={() => navigateToOrigin()}
      >
        {t(contractTranslation.changeBankAccount.step1.buttons.previous.label)}
      </OreButton>
      {!simplified ? (
        <OreButton
          data-testid="next"
          category={'primary'}
          onClick={handleSubmit(getSepaDocument)}
        >
          {t(contractTranslation.changeBankAccount.step1.buttons.next.label)}
        </OreButton>
      ) : null}
    </OreStack>
  )
}
